import Api from '../Api';

class AddressApi extends Api {
  constructor() {
    super('addresses', 'addresses');
  }
}
const addressApi = new AddressApi();
export default addressApi;
